import type { Asset } from "rujira.js";

// Secured and layer-1 representations share a token, but same-chain tokens
// with different contracts (including wrapped tokens) still require a swap.
export const isSameTransferAsset = (left: Asset, right: Asset): boolean => {
  const identity = (asset: Asset): string => {
    const layer1 = asset.variants?.layer1 || asset;
    const identifier =
      layer1.type === "SECURED"
        ? layer1.asset.replace(/^(\w+)-/, "$1.")
        : layer1.asset;
    return identifier.replace(/-0x[0-9a-f]+$/i, (contract) =>
      contract.toLowerCase()
    );
  };
  return identity(left) === identity(right);
};

export type WithdrawAmountIssue = "exceedsBalance" | "belowFee";

/** Why a withdrawal amount must not be submitted, if there is a reason. */
export const withdrawAmountIssue = ({
  amount,
  balance,
  received,
}: {
  amount: bigint;
  balance: bigint;
  /** Undefined while the amount received is still unknown (e.g. quote loading). */
  received?: bigint;
}): WithdrawAmountIssue | undefined => {
  if (amount <= 0n) return undefined;
  if (amount > balance) return "exceedsBalance";
  // A withdrawal that cannot cover its fee is refunded minus fees on-chain.
  if (received !== undefined && received <= 0n) return "belowFee";
  return undefined;
};
